const state = () => ({
  all: [],
})

const getters = {
  all:        state => state.all,
}

const actions = { 
}

const mutations = { 
  APPEND (state, items) {
    state.all.push(items)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}